import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { InformationSideBar } from '../components/InformationSideBar';

export const InformationSideBarProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <InformationSideBar {...data} />
        </Provider>
    );
};

InformationSideBarProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
